<template>
<div class="my-breadcrumb bg-fff">
  <Breadcrumb>
    <BreadcrumbItem v-for="(item,index) in list" :key="index" :to="item.url">{{ item.title }}</BreadcrumbItem>
  </Breadcrumb>
</div>
</template>

<script>
export default {
  name: "BreadCrumb",
  props:{
    list:{
      type:Array,
      required:true,
      default:()=>{
        return []
      }
    }
  }
}
</script>

<style scoped>
.my-breadcrumb {
  padding: 13px 24px 8px 24px;
  border-bottom: 1px solid #e8e8e8;
}
.bg-fff {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BreadCrumb.vue